import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import DesktopOnlyNoticeImage from '@backrs_ui/common-ui/src/assets/images/desktop-only-notice.png';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';

import { Box, Typography, Stack, SxProps, Theme, Button } from '@mui/material';

const { desktopOnlyNotice } = appStrings.modules;

export const DesktopOnlyNotice = () => {
  const copyLink = () => {
    navigator.clipboard.writeText(location.href);
  };

  return (
    <Box sx={wrapperStyle}>
      <Box sx={overlayStyle} />
      <Box sx={cardWrapperStyle}>
        <Box sx={cardStyle}>
          <Stack sx={containerStyle}>
            <Box component="img" src={DesktopOnlyNoticeImage} sx={imageStyle} />
            <Stack sx={bodyStyle}>
              <Typography variant="text-lg-semibold" sx={titleStyle}>
                {desktopOnlyNotice.title}
              </Typography>
              <Typography variant="text-sm-regular" sx={descriptionStyle}>
                {desktopOnlyNotice.description}
              </Typography>
            </Stack>
            <Button
              startIcon={
                <AppIcon iconName="Copy01" diameter="20px" color="Colors/Foreground/fg-secondary" />
              }
              sx={buttonStyle}
              onClick={copyLink}
            >
              {desktopOnlyNotice.copyLink}
            </Button>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

const wrapperStyle: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  position: 'relative',
};

const overlayStyle: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  height: '100%',
  backgroundColor: backrs.colors['Colors/Base/Black'],
  opacity: 0.2,
  position: 'absolute',
  top: 0,
  left: 0,
});

const cardWrapperStyle: SxProps<Theme> = {
  ...wrapperStyle,
  display: 'grid',
  placeItems: 'center',
};

const cardStyle: SxProps<Theme> = ({ backrs }) => ({
  overflow: 'hidden',
  border: '1px solid black',
  borderRadius: backrs.radius['radius-xl'],
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
  marginLeft: backrs.spacing['spacing-xl'],
  marginRight: backrs.spacing['spacing-xl'],
  padding: backrs.spacing['spacing-xl'],
  boxShadow: backrs.shadows['shadow-xl'],
  transform: 'translate(-2px, -2px)',
  '&:active': {
    outline: 'none',
    transform: 'translate(0px, 0px)',
    boxShadow: 'none',
    transition: 'all 0s',
  },
  fontFamily: 'Sarabun, sans-serif',
  maxWidth: '375px',
});

const containerStyle: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  rowGap: backrs.spacing['spacing-3xl'],
});

const bodyStyle: SxProps<Theme> = ({ backrs }) => ({
  rowGap: backrs.spacing['spacing-md'],
  alignItems: 'center',
  textAlign: 'center',
});

const imageStyle: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  objectFit: 'cover',
  borderRadius: backrs.radius['radius-md'],
});

const titleStyle: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
  fontFamily: 'inherit',
});

const descriptionStyle: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
  fontFamily: 'inherit',
  maxWidth: '310px',
});

const buttonStyle: SxProps<Theme> = ({ backrs, typography }) => ({
  width: '100%',
  color: backrs.colors['Colors/Foreground/fg-secondary'],
  border: `1px solid ${backrs.colors['Colors/Foreground/fg-secondary']}`,
  borderRadius: backrs.radius['radius-md'],
  fontFamily: 'inherit',
  textTransform: 'capitalize',
  ...typography['text-md-semibold'],
});
